/**
 * A Stimulus controller that formats email input fields by adding semicolons.
 * @module EmailInputController
 *
 * This controller can be used to format email input fields by adding semicolons
 * after each email address, similar to the behavior in Outlook.
 *
 * @example
 *  HTML that uses the EmailInputController to format email addresses:
 *
 *  <input type="text" data-controller="email-input" data-action="blur->email-input#formatEmail" data-email-input-target="emailField">
 *
 *  When the input field loses focus, the email addresses will be formatted with semicolons:
 *  Input: "example1@example.com example2@example.com"
 *  Output: "example1@example.com; example2@example.com"
 *
 *  Input: "example1@example.com, example2@example.com"
 *  Output: "example1@example.com; example2@example.com"
 */

import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['emailField'];

  formatEmail(event) {
    const input = event.target;
    const value = input.value.trim();

    if (value) {
      // Split by semicolons, commas, or whitespace, and filter out empty values
      const emails = value.split(/[,;\s]+/).filter((email) => email.length > 0);

      // Add a semicolon after each email except the last one
      input.value = emails.map(function (email, index) {
        return index === emails.length - 1 ? email : `${email};`;
      }).join(' ');
    }
  }
}
